// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3CuwJ","tab":"ProcedureTabs_tab__2CWwC"};